module.exports = __webpack_public_path__ + "static/img/wodeaiche.5d1140a1.png";